import { useQuery } from "react-query";
import { getActiveEmployees } from "../../../../../actions/CarrierAgreementMgmt/Reports";

const useGetActiveEmployees = () => {
  return useQuery("GetActiveEmployees", getActiveEmployees, {
    refetchOnWindowFocus: false,
  });
};
export default useGetActiveEmployees;
